import { useQuery, useQueryClient } from '@tanstack/react-query';
import { cartAPI } from '../api/endpoints';

export const CART_QUERY_ROOT = 'cart';

/** Clé React Query partagée (CartContext, /cart, drawer, checkout). */
export function getCartQueryKey(userId) {
  return [CART_QUERY_ROOT, userId];
}

export const cartQueryOptions = {
  staleTime: 0,
  refetchOnWindowFocus: true,
  refetchOnMount: 'always',
  retry: 1,
};

/**
 * GET panier serveur — statuts produits à jour à chaque refetch (rupture vendeur).
 */
export function useCartQuery(userId, { enabled = true } = {}) {
  return useQuery({
    queryKey: getCartQueryKey(userId),
    queryFn: () => cartAPI.getCartItems(userId),
    enabled: Boolean(userId && enabled),
    ...cartQueryOptions,
  });
}

/** Invalide le cache panier (après ouverture drawer, navigation checkout, etc.). */
export function useInvalidateCartQuery() {
  const queryClient = useQueryClient();
  return (userId) => {
    if (!userId) return;
    queryClient.invalidateQueries({ queryKey: getCartQueryKey(userId) });
  };
}
